// Разворачиваем документ CRM: формы, списки выбора и просмотр скриншотов остаются
// внутри fullscreen-элемента, даже когда замечание приходит из iframe виджета.
export const toggleQaFullscreen = async () => {
  if (document.fullscreenElement) await document.exitFullscreen();
  else await document.documentElement.requestFullscreen?.();
};
